/**
 * Created by seongjunkim on 2017-07-21.
 */
import React from 'react'
import PropTypes from 'prop-types'
import { _FilterSection, _FilterTitle, _ChildrenContainer } from './styles'

const AdvanceFilterSection = ({ sectionTitle, children, showMobileVersion, isForSideBar }) =>
  (
    <div key={sectionTitle}>
      <_FilterSection
        forMobile={showMobileVersion}
        isForSideBar={isForSideBar}
      >
        {sectionTitle && (
          <_FilterTitle
            forMobile={showMobileVersion}
            forSideBar={isForSideBar}
          >
            {sectionTitle}
          </_FilterTitle>
        )}
        <_ChildrenContainer
          row={children && children.length > 1}

        >
          {children}
        </_ChildrenContainer>
      </_FilterSection>
    </div>
  )

AdvanceFilterSection.propTypes = {
  sectionTitle: PropTypes.string,
  showMobileVersion: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element),
  isForSideBar: PropTypes.bool,
}

export default AdvanceFilterSection
